import React, { forwardRef, useImperativeHandle, useRef, useState, useEffect } from "react";
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Close';
import Button from '@mui/material/Button';
import LockResetIcon from '@mui/icons-material/LockReset';
import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import Tooltip from "@mui/material/Tooltip";
import {
    GridRowModes,
    DataGrid,
    GridToolbarContainer,
    GridActionsCellItem,
    GridRowEditStopReasons,
    GridEditInputCell
} from '@mui/x-data-grid';
import { v4 as uuidv4 } from 'uuid';

import { Autocomplete, TextField } from "@mui/material";
import Helper from '../../Helper';

const Component = forwardRef((props, ref) => {
    const roles = [{ text: "admin", value: 1 }, { text: "user", value: 2 }, { text: "accountant", value: 3 }, { text: "billing", value: 4 }]
    const [rows, setRows] = React.useState([]);
    const [rowModesModel, setRowModesModel] = React.useState({});
    const setError = (message, ismessage) => props.setError?.apply(this, [message, ismessage]);
    const [rowError, setRowError] = useState({});
    const [deleteRowId, setDeleteRowId] = useState(null);
    const [resetRowId, setResetRowId] = useState(null);
    const [loadingRow, setLoadingRow] = useState(null); // Track loading state

    const getuser = async () => {
        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/getUser`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${Helper.gettoken()}`,
                    'Content-Type': 'application/json'
                }
            });

            if (response.ok) {
                const data = await response.json();
                setRows(data.result);
            } else {
                const data = await response.json();
                setError(data.message || 'Failed to fetch user');
            }
        } catch (err) {
            setError('An error occurred while fetching user.');
        }
    }
    useEffect(() => {

        getuser();


    }, []);
    const handleRowEditStop = (params, event) => {
        if (params.reason === GridRowEditStopReasons.rowFocusOut) {
            event.defaultMuiPrevented = true;
        }
    };

    const handleEditClick = (id) => () => {
        setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.Edit } });
    };

    const handleSaveClick = (id) => () => {
        setRowModesModel({ ...rowModesModel, [id]: { mode: GridRowModes.View } });

    };
    const validateRow = (newRow) => {
        if (!newRow.username) return "กรุณาระบุ UserName";
        if (!newRow.name) return "กรุณาระบุ ชื่อ-สกุล";
        if (!newRow.email) return "กรุณาระบุ E-mail";
        if (!newRow.tel) return "กรุณาระบุ เบอร์โทร";
        if (!newRow.role_name) return "กรุณาระบุ Role";
        return null; // No errors
    };
    const handleProcessRowUpdate = async (newRow, oldRow) => {
        const error = validateRow(newRow);

        if (error) {
            setRowError((prev) => ({ ...prev, [newRow.id]: error })); // Store error
            throw new Error(error); // Prevent leaving edit mode
        }

        setRowError((prev) => ({ ...prev, [newRow.id]: undefined })); // Clear error

        var response = await saveData(newRow);
        newRow.rowid = response.rowid;
        setRows((prev) => prev.map((row) => (((row.id && newRow.id && row.id === newRow.id) || row.rowid == newRow.rowid) ? newRow : row)));
        return newRow;
    };
    const saveData = async (row) => {
        try {
            setLoadingRow(row.id); // Show loading
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/saveUser`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${Helper.gettoken()}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ user: row }),

            });
            const data = await response.json();
            if (response.ok) {
                setLoadingRow(null);

                setError("บันทึกข้อมูลเรียบร้อยแล้ว", true);
                return data.user;
            } else {
                setLoadingRow(null);
                throw new Error(data.message);
            }

        } catch (error) {
            setLoadingRow(null);
            throw new Error(error.message || "Failed to save data. Try again.");
        }
    };
    const handleDeleterowClick = (row) => () => {
        setDeleteRowId(row.rowid); // Open confirmation dialog
    };
    const handleResetrowClick = (row) => () => {
        setResetRowId(row.rowid); // Open confirmation dialog
    };

    const handleDeleteClick = async () => {
        var deleterow = rows.find((row) => row.rowid == deleteRowId)
        setLoadingRow(deleterow.rowid);
        await deleteUser(deleterow.rowid)
        setRows(rows.filter((row) => row.rowid != deleteRowId));
        setDeleteRowId(null);
    };

    const deleteUser = async (rowid) => {
        try {

            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/deleteUser/${rowid}`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${Helper.gettoken()}`,
                    'Content-Type': 'application/json'
                }

            });
            const data = await response.json();
            if (response.ok) {
                setLoadingRow(null);

                setError("บันทึกข้อมูลเรียบร้อยแล้ว", true);
                return data;
            } else {
                setLoadingRow(null);

                throw new Error(data.message);
            }

        } catch (error) {
            setLoadingRow(null);

            throw new Error(error.message || "Failed to save data. Try again.");
        }
    };

    const resetPassword = async () => {
        try {
            var row = rows.find((row) => row.rowid == resetRowId)
            setLoadingRow(row.rowid);
            const response = await fetch(`${process.env.REACT_APP_API_URL}/api/resetPassword/${row.username}`, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${Helper.gettoken()}`,
                    'Content-Type': 'application/json'
                }

            });
            const data = await response.json();
            if (response.ok) {
                setLoadingRow(null);
                setResetRowId(null);
                setError("บันทึกข้อมูลเรียบร้อยแล้ว", true);
                return data;
            } else {
                setLoadingRow(null);
                setResetRowId(null);
                throw new Error(data.message);
            }

        } catch (error) {
            setLoadingRow(null);
            setResetRowId(null);
            throw new Error(error.message || "Failed to save data. Try again.");
        }
    };
    const handleCancelClick = (id) => () => {
        setRowModesModel({
            ...rowModesModel,
            [id]: { mode: GridRowModes.View, ignoreModifications: true },
        });

        const editedRow = rows.find((row) => row.id === id);
        if (editedRow && editedRow.isNew) {
            setRows(rows.filter((row) => row.id !== id));
        }
    };


    const handleRowModesModelChange = (newRowModesModel) => {
        setRowModesModel(newRowModesModel);
    };

    const setItem = (event, newValue, params) => {
        if (!newValue) {
            params.api.setEditCellValue({ id: params.id, field: params.field, value: "user" })
            params.api.setEditCellValue({ id: params.id, field: "role_id", value: 2 })

            return;
        };
        params.api.setEditCellValue({ id: params.id, field: params.field, value: newValue.text })
        params.api.setEditCellValue({ id: params.id, field: "role_id", value: newValue.value })
    }


    const columns = [
        {
            sortable: true,
            field: 'rownum',
            headerName: '#',
            flex: 0,
            editable: false,
            width: 50,
            renderCell: (params) => params.api.getAllRowIds().indexOf(params.id) + 1

        },
        {
            field: 'rowid',
            headerName: 'rowid',
            editable: true,
            hide: true,
        },
        {
            field: 'username',
            headerName: 'UserName',

            flex: 1,
            editable: true,

        },
        {
            field: 'name',
            headerName: 'ชื่อ - สกุล',
            flex: 1,

            editable: true,

        },
        {
            field: 'email',
            headerName: 'E-mail',

            flex: 1,
            editable: true,

        },
        {
            field: 'tel',
            headerName: 'เบอร์โทร',

            flex: 1,
            editable: true,

        },
        {
            field: 'role_name',
            headerName: 'Role',

            width: 200,
            editable: true,
            renderEditCell: (params) => (<Autocomplete
                fullWidth

                defaultValue={roles.find((role) => role.text === params.value) || params.value}
                onChange={(event, newValue) => setItem(event, newValue, params)}
                getOptionLabel={(option) => (typeof option === "string" ? option : option.text)}
                options={roles}
                renderInput={(params) => <TextField {...params} />}
            />)

        },
        {
            field: 'role_id',

            editable: true,

        },
        {
            field: 'isadmin',

            editable: true,

        },

        {
            field: 'actions',
            type: 'actions',
            headerName: 'แก้ไข',
            width: 100,
            cellClassName: 'actions',
            getActions: ({ id, row }) => {
                const isInEditMode = rowModesModel[id]?.mode === GridRowModes.Edit;

                if (isInEditMode) {
                    return [
                        <GridActionsCellItem
                            icon={<Tooltip title="บันทึก"><SaveIcon /></Tooltip>}
                            label="Save"
                            sx={{
                                color: 'primary.main',
                            }}
                            onClick={handleSaveClick(id)}
                            disabled={loadingRow == id}
                        />,
                        <GridActionsCellItem
                            icon={<Tooltip title="ยกเลิก"><CancelIcon /></Tooltip>}
                            label="Cancel"
                            className="textPrimary"
                            onClick={handleCancelClick(id)}
                            disabled={loadingRow == id}
                            color="inherit"
                        />,
                    ];
                }

                return [
                    <GridActionsCellItem
                        icon={<Tooltip title="รีเซ็ตรหัสผ่าน"><LockResetIcon /></Tooltip>}
                        label="รีเซ็ตรหัสผ่าน"
                        className="textPrimary"
                        onClick={handleResetrowClick(row)}
                        disabled={loadingRow == row.rowid}
                        color="inherit"
                    />,
                    <GridActionsCellItem
                        icon={<Tooltip title="แก้ไข"><EditIcon /></Tooltip>}
                        label="Edit"
                        className="textPrimary"
                        onClick={handleEditClick(id)}
                        disabled={loadingRow == row.rowid}
                        color="inherit"
                    />,
                    <GridActionsCellItem
                        icon={<Tooltip title="ลบ"><DeleteIcon /></Tooltip>}
                        label="Delete"
                        hidden={row.isadmin}
                        onClick={handleDeleterowClick(row)}
                        disabled={loadingRow == row.rowid}
                        color="inherit"
                    />,
                ];
            },
        },


    ];

    function EditToolbar(props1) {
        const { setRows, setRowModesModel } = props1;

        const handleClick = () => {
            const id = uuidv4();
            setRows((oldRows) => [
                ...oldRows,
                { id, isNew: true },
            ]);
            setRowModesModel((oldModel) => ({
                ...oldModel,
                [id]: { mode: GridRowModes.Edit, fieldToFocus: 'username' },
            }));
        };

        return (
            <GridToolbarContainer>
                <Button color="primary" startIcon={<AddIcon />} onClick={handleClick}>
                    เพิ่มผู้ใช้
                </Button>
            </GridToolbarContainer>
        );
    }

    return (<>

        <DataGrid key={props.index}
            getRowId={(row) => row.id || uuidv4()}
            rows={rows}
            columns={columns}
            editMode="row"
            rowModesModel={rowModesModel}
            onRowModesModelChange={handleRowModesModelChange}
            onRowEditStop={handleRowEditStop}

            slots={{ toolbar: EditToolbar }}
            slotProps={{
                toolbar: { setRows, setRowModesModel },
            }}
            isCellEditable={(params) => {
                if (params.field == "role_name" && params.row.isadmin === 1) return false;
                else return true;

            }}

            columnVisibilityModel={{

                role_id: false,
                isadmin: false,
                rowid: false,

            }}

            processRowUpdate={handleProcessRowUpdate} // Prevents exit if invalid
            onProcessRowUpdateError={(error) => setError(error.message)} // Show error message
            hideFooter
        />

        <Dialog open={!!deleteRowId} onClose={() => setDeleteRowId(null)}>
            <DialogTitle>ยืนยันที่จะลบ</DialogTitle>
            <DialogContent>ต้องการที่จะลบรายการหรือไม่?</DialogContent>
            <DialogActions>
                <Button onClick={() => setDeleteRowId(null)}>ยกเลิก</Button>
                <Button onClick={handleDeleteClick} color="error">ลบ</Button>
            </DialogActions>
        </Dialog>

        <Dialog open={!!resetRowId} onClose={() => setResetRowId(null)}>
            <DialogTitle>ยืนยันที่จะรีเซ็ตรหัสผ่าน</DialogTitle>
            <DialogContent>ต้องการที่จะรีเซ็ตรหัสผ่านหรือไม่?</DialogContent>
            <DialogActions>
                <Button onClick={() => setResetRowId(null)}>ยกเลิก</Button>
                <Button onClick={resetPassword} color="error">ยืนยัน</Button>
            </DialogActions>
        </Dialog>

    </>

    );
});



export default Component;